









import {Component, Vue} from 'vue-property-decorator'
import VueQueryBuilder from "vue-query-builder"
import "vue-query-builder/dist/VueQueryBuilder.css"

@Component({
  components: {
    VueQueryBuilder
  }
})
export default class QueryBuilderView extends Vue {
  private rules = [
    {
      type: "text",
      id: "vegetable",
      label: "Vegetable",
    },
    {
      type: "radio",
      id: "fruit",
      label: "Fruit",
      choices: [
        {label: "Apple", value: "apple"},
        {label: "Banana", value: "banana"}
      ]
    },
  ]

  private query = {}
}
